import React, { Component } from 'react';
import classNames from 'classnames';
import SearchIcon from '../../../assets/svg/search/search-gray.svg?react';
import styles from './FJTransverse.module.less';

class FJTransverse extends Component {
    _onMouseEnter = () => {
        this.props.onMouseEnter && this.props.onMouseEnter();
    };
    render() {
        let { keyword, onClick, active } = this.props;
        return (
            <div
                className={classNames(styles.box, active ? styles.active : '')}
                onClick={onClick}
                onMouseEnter={this._onMouseEnter}
            >
                <SearchIcon />
                <div className={styles.text}>{keyword}</div>
            </div>
        );
    }
}

export default FJTransverse;
